import React, {useEffect, useState} from 'react'
import './NetWorthModal.scss'
import {AddOrderData} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {isNanHandler, numberFormat} from "../../util";
import fetchQuery from "relay-runtime/lib/query/fetchQuery";
import environment from "../../Environment";
import PortfolioQuery from "../../queries/PortfolioQuery";
import {assetUrl} from "../../serviceApi";

const wrong_image = assetUrl+'images/wrong_image.svg'
const image = assetUrl+'images/net-worth-tray-image-large.png'


const NetWorthModal = (props) => {
	const {setActiveModal, wallet_data} = props;
	const [portfolioData, setPortfolioData] = useState({});

	useEffect(() => {
		getPortfolioData();
	}, [])

	const getPortfolioData = () => {
		let variable = {}

		fetchQuery(environment, PortfolioQuery, variable)
			.toPromise()
			.then(response => {

				if (response.userPortfolio !== null) {
					setPortfolioData(response.userPortfolio)

				} else {
					setPortfolioData({})

				}
			}, err => {

				console.log(err);
				setPortfolioData({})
			});
	}

	return (
		<div className={'wallet-netWorth'}>
			<div className="wallet-net-banner ">
				<div className="wallet-net-banner-wrong_text" onClick={() => setActiveModal("")}>
					<img src={wrong_image} alt="Italian-Trulli" className="wallet-net-banner-wrong_icon"/>
				</div>
			</div>
			<div className="wallet-net-card ">
				<div className={'d-flex justify-content-between mx-4 mt-1'}>
					<div>
						<p className={"title mb-2"}>NET WORTH</p>
						<p className={"title-value mb-0"}>{numberFormat(isNanHandler(wallet_data.availableNettWorth))}</p>
					</div>
					<img src={image} alt={"alt"} className={"net-worth-image"}/>
				</div>
				<hr className={"mx-2"}/>
				<div className={"mx-4"}>
					<div className={'d-flex w-100 justify-content-between mb-2'}>
						<p className={"sub-text"}>Cash Balance</p>
						<p className={"sub-text-value"}>{numberFormat(isNanHandler(wallet_data.cashBalance))}</p>
					</div>
					<div className={'d-flex w-100 justify-content-between  mt-1 mb-2'}>
						<p className={"sub-text"}>Current Portfolio Value </p>
						<p className={"sub-text-value"}>{numberFormat(isNanHandler(portfolioData.marketCurrentTotal))}</p>
					</div>
					<div className={'d-flex w-100 justify-content-between mt-1 mb-2'}>
						<p className={"sub-text"}>Bonus Money</p>
						<p className={"sub-text-value"}>{numberFormat(isNanHandler(wallet_data.availableGrantMoney))}</p>
					</div>
				</div>


			</div>
			<hr className={"mb-4"}/>
		</div>
	)
}
// const mapStateToProps = state => ({
// 	wallet_data: state.WalletReducer.wallet_data
// });

const mapDispatchToProps = dispatch => ({
	sendOrderDatasToStore: order_data => dispatch(AddOrderData(order_data)),
});

export default compose(
	withRouter,
	connect(null, mapDispatchToProps)
)(NetWorthModal);

